// extracted by mini-css-extract-plugin
module.exports = {"container":"container--NoSmartListSpace-NoResults-components__J3HJP","icon":"icon--NoSmartListSpace-NoResults-components__2ntwA"};